import {useLayoutEffect, useRef, useState} from 'react';

/* The card is laid out at this fixed native size; the ratio is constant (portrait poster + chrome),
   so the size is a constant — no per-card measuring needed, only the scale that fits it on screen. */
export const CARD_NATIVE_W = 330;
export const CARD_NATIVE_H = 690;
const FILL = 0.95;

/** Returns the scale that fits the native-size card into `areaRef` on both axes,
 *  so text and chrome shrink together (like the Tickchak DS zoom) instead of overflowing. */
export default function useFitScale() {
    const areaRef = useRef<HTMLDivElement>(null);
    const [scale, setScale] = useState(1);

    useLayoutEffect(() => {
        const node = areaRef.current;
        if(!node)
            return;

        const update = () => {
            const {width, height} = node.getBoundingClientRect();
            if(!width || !height)
                return;
            const next = Math.min(width / CARD_NATIVE_W, height / CARD_NATIVE_H) * FILL;
            setScale(prev => Math.abs(prev - next) > 0.001 ? next : prev);
        };

        const observer = new ResizeObserver(update);
        observer.observe(node);
        update();
        return () => observer.disconnect();
    }, []);

    return {areaRef, scale};
}
